import { Button, Modal } from 'antd';
import React, { useState } from 'react';
import 'antd/dist/antd.css';
import './style.scss';
import WhatsappImg from '../../../../../../assets/images/communication/WHatsapp.svg';
import OtpInput from 'react-otp-input';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';

const RefundModal = ({ issueRefundModalVisible, setIssueRefundModalVisible, handleGenerateOtp,handleFormSubmitWithVerification, whatsappNumber }) => {
  const [code, setCode] = useState('');
  const [actionButtonsDisabled, setActionButtonsDisabled] = useState(false);
  const onResendClick = () => {
    setActionButtonsDisabled(true);
    handleGenerateOtp({isResend : true});
  };

  const onResendWaitComplete = () => {
    setActionButtonsDisabled(false);
  };
  return (
    <Modal
      open={issueRefundModalVisible}
      onCancel={() => setIssueRefundModalVisible(false)}
      title={'Enter reference number'}
      centered
      footer={
        <div className="modal-footer">
          <button className="btn-outline" onClick={() => setIssueRefundModalVisible(false)}>
            Close
          </button>
          <button className={'btn-primary'}>Submit</button>
        </div>
      }
      className="refund-modal">
      <div className="modal-title">
        Reference number is sent via WhatsApp <img src={WhatsappImg} /> to customer mobile no.
        <span> +91{whatsappNumber}</span>
      </div>
      <OtpInput
        value={code}
        onChange={(_code) => {
          setCode(_code);
          if (_code.length === 4) {
           handleFormSubmitWithVerification (_code)
          }
        }}
        numInputs={4}
        renderInput={(props) => <input {...props} />}
        containerStyle={{
          marginTop: 40,
          marginBottom: 16,
        }}
        inputStyle={{
          height: 48,
          width: '50%',
          marginLeft: 8,
          borderRadius: 8,
        }}
      />
      <div className="actionButtonsContainer">
        <div className="resendContainer">
          <div
            className={`actionButton ${actionButtonsDisabled ? 'actionButtonDisabled' : null}`}
            width="100%"
            onClick={onResendClick}
            disabled={actionButtonsDisabled}>
            Resend OTP
          </div>
        </div>
        {actionButtonsDisabled ? (
          <CountdownCircleTimer
            colors={'#0067E2'}
            isPlaying
            duration={60}
            size={28}
            strokeWidth={3}
            strokeLinecap={0}
            trailStrokeWidth={0}
            onComplete={onResendWaitComplete}>
            {({ remainingTime }) => (
              <div className="countdownBackgroundCont">
                <div className="countdownBackground" />
                <div className="countdownTime">{remainingTime}</div>
              </div>
            )}
          </CountdownCircleTimer>
        ) : null}
      </div>
    </Modal>
  );
};
export default RefundModal;
